import React, { useState, useEffect, useContext } from "react";
import QuickDate from "../../../components/QuickDate";
import { UserContext } from "../../../App";
import "./index.scss";
import UserSelector from "../../../components/UserSelector";
import Layout from "../../../Layouts/Layout";
import ReportTable from "./components/ReportTable";
import VersatileLoader from "../../../components/VersatileLoader";
import CustomerApi from "../../../API/CustomerApi";
import OrganizationSelector from "../../../components/OrganizationSelector";

const OffersReport = () => {
  const user = useContext(UserContext);
  const [userWithName, setUserWithName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [salesRepIds, setSalesRepIds] = useState([]);
  const [salesOrgId, setSalesOrgId] = useState(null);
  const [filterBy, setFilterBy] = useState("");
  const [offersReport, setOffersReport] = useState([]);

  // getSalesReps
  const getOffersReport = async () => {
    setLoading(true);
    const req = {
      salesRepIds: salesRepIds,
      salesOrgId: salesOrgId === -1 ? null : salesOrgId,
    };
    if (user.userType === "SalesRep") {
      req.salesRepIds = [user.id];
    }
    if (user.userType === "SalesOrgAdmin") {
      if (salesOrgId === -1) {
        req.salesOrgId = null;
      } else {
        req.salesOrgId = user.salesOrgId;
      }
    }
    if (startDate && endDate) {
      req.startDate = startDate;
      req.endDate = endDate;
    }
    try {
      const res = await CustomerApi.GetOfferStatusesWithSalesReps(req);
      console.log("salesReps", res);
      setOffersReport(res?.data || []);
    } catch (error) {
      console.error("Failed to fetch sales reps:", error);
      setOffersReport([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getOffersReport();
  }, []);

  return (
    <Layout>
      <div className="offers-report-container">
        <div className="filter-container">
          {/* {user.userType === "SalesOrgAdmin" && (
            <div className="toggle-switch">
              <label>Viewing: {filterBy}</label>
              <input
                type="checkbox"
                checked={filterBy === "Team"}
                onChange={() => setFilterBy(filterBy === "Me" ? "Team" : "Me")}
              />
            </div>
          )} */}

          <QuickDate setFrom={setStartDate} setTo={setEndDate} />
          <div className="w-full mt-4">
            {(user.userType === "SuperAdmin" ||
              user.userType === "SalesOrgAdmin") && (
              <div className="single">
                <UserSelector
                  includeYourself={true}
                  SalesOrgId={
                    user.userType === "SalesOrgAdmin" ? user.salesOrgId : null
                  }
                  setUser={setSalesRepIds}
                  userWithName={userWithName}
                  setUserWithName={setUserWithName}
                  conversationType={"Group"}
                  placeholder="Select Sales Reps"
                  userTypes={["SalesRep", "SalesOrgAdmin"]}
                />
              </div>
            )}
          </div>
          <div className="w-full mt-4">
            {user.userType === "SuperAdmin" && (
              <div className="single">
                <OrganizationSelector
                  setUser={setSalesOrgId}
                  conversationType={"Group"}
                  placeholder="Select Sales Org"
                />
              </div>
            )}
          </div>

          <button onClick={getOffersReport}>Fetch Report</button>
        </div>
        {loading ? (
          <div className="mt-20">
            <VersatileLoader size="large" color="gray" />
          </div>
        ) : (
          <ReportTable
            offersReport={offersReport}
            startDate={startDate}
            endDate={endDate}
          />
        )}
      </div>
    </Layout>
  );
};

export default OffersReport;
